import * as services from "./start/startService";

export {
    services
}


// WEBPACK FOOTER //
// ./src/js/services/index.js